import { pushEventToGTMDataLayer } from 'application/gtm_utils'

export function studentExpired() {
  pushEventToGTMDataLayer({ event: 'student_expired' });
}
